module.exports = __webpack_public_path__ + "static/media/icomoon.fbe91768.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.eot?l3qv7r
// module id = 1084
// module chunks = 32